export default __webpack_public_path__ + "static/media/area-56.41b8a3ca.jpg";